import styled from 'styled-components';

export const ControllerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  > div {
    margin-top: 0;
  }
`;
